import { useTranslation } from "react-i18next"

import InputNumber from "../../../../../../../Components/Input/InputNumber"
import { tLiteral } from "../../../utils/questionText"

const NumberControl = ({ question, value, status, onChange, onTouch }) => {
  const { t } = useTranslation()
  return (
    <InputNumber
      value={value === "" || value == null ? null : Number(value)}
      placeholder={tLiteral(t, question.placeholder)}
      min={0}
      // Money fields (e.g. "Above what amount do you require CVV?") show a $ prefix.
      prefix={question.prefix || undefined}
      onChange={(v) => onChange(v === null || v === undefined ? "" : String(v))}
      onBlur={onTouch}
      status={status}
      style={{ width: 200 }}
    />
  )
}

export default NumberControl
